import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { Domain } from '../../../models/domain.model';
import { PaginatedList } from 'src/app/xform-compat';
import { DomainService } from 'src/app/core/data-services/domain.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'rms-domain-filter',
    templateUrl: './domain-filter.component.html',
    styleUrls: ['./domain-filter.component.scss'],
    standalone: false
})
export class DomainFilterComponent implements OnInit, OnDestroy {
  @Output() domainFilterToggleEvent = new EventEmitter();
  @Input() resetFilterSubject: Subject<any>;
  /** Pre-selected domain IDs to restore from persisted filter state. */
  @Input() initialDomainIds: Array<number> = [];
  /**
   * Layout preset for the chip row:
   * - `default`: the standard 90px-capped compact row (filter panes).
   * - `inline`: uncapped single row of compact chips (desktop filter toolbars).
   * - `grid`: wider 30px touch chips wrapping four-per-row (mobile drawers).
   */
  @Input() variant: 'default' | 'inline' | 'grid' = 'default';

  loading = false;
  domainFilters: Array<Domain> = new Array<Domain>();
  domainFilterState: Set<number> = new Set<number>();

  constructor(
    private domainService: DomainService
  ) { }

  ngOnInit() {
    this.loadDomains();
    this.resetFilterSubject.subscribe(event => {
      this.domainFilterState = new Set<number>();
    });
  }

  ngOnDestroy() {
    this.resetFilterSubject.unsubscribe();
  }

  public getDomainFilterLabel(shortName: string): string {
    if (shortName.toLowerCase() === 'genmed') {
 return 'gen';
}

    return shortName;
  }

  public toggleFilter(filterId: number) {
    if (this.domainFilterState.has(filterId)) {
this.domainFilterState.delete(filterId);
} else {
this.domainFilterState.add(filterId);
}
    const domainIds = Array.from(this.domainFilterState);

    this.domainFilterToggleEvent.emit(domainIds);
  }

  public isActive(filterId: number) {
    return this.domainFilterState.has(filterId);
  }

  private loadDomains() {
    this.loading = true;

    this.domainService.domains.subscribe((resp: PaginatedList<Domain>) => {
      this.loading = false;

      if (resp) {
        this.domainFilters = resp.records;
      } else {
        this.domainFilters = [];
      }

      // Restore persisted domain selections after domains have loaded
      if (this.initialDomainIds?.length > 0) {
        this.domainFilterState = new Set<number>(this.initialDomainIds);
      }
    }, () => {
      this.domainFilters = [];
      this.loading = false;
    });
  }
}
